import type { ProductType, VerificationType } from 'api/types';

export type OrderProductTypeInfo = {
  name: string;
  value: VerificationType;
};

export const providerProductTypeValues: OrderProductTypeInfo[] = [
  {
    name: 'Income and employment',
    value: 'income',
  },
  {
    name: 'Employment history',
    value: 'employment',
  },
  {
    name: 'Direct deposit switch',
    value: 'deposit_switch',
  },
  {
    name: 'Paycheck linked loans',
    value: 'pll',
  },
];

export const providerProductTypes = providerProductTypeValues.map((product) => product.value);

// 'transactions' is not provider product type
export const baseOrderProductTypes: OrderProductTypeInfo[] = [
  ...providerProductTypeValues,
  {
    name: 'Transactions',
    value: 'transactions',
  },
];

export const baseProductTypes = baseOrderProductTypes.map((product) => product.value);

export const additionalOrderProductTypes: OrderProductTypeInfo[] = [
  {
    name: 'Assets',
    value: 'assets',
  },
  {
    name: 'Insurance',
    value: 'insurance',
  },
];

export const orderProductTypeValues: OrderProductTypeInfo[] = [
  ...baseOrderProductTypes,
  ...additionalOrderProductTypes,
];

export const orderProductTypesMap = orderProductTypeValues.reduce<Record<VerificationType, string>>(
  (acc, product) => {
    acc[product.value] = product.name;

    return acc;
  },
  {} as Record<VerificationType, string>,
);

export const PRODUCTS_WITH_MAPPING_AND_PROVIDER: ProductType[] = ['income', 'employment', 'deposit_switch', 'pll'];
export const PRODUCTS_WITH_FINANCIAL_INSTITUTION: ProductType[] = ['assets', 'transactions'];
export const PRODUCTS_WITH_ACCOUNT = ['deposit_switch', 'pll'];
